export const categories = [
  {
    slug: "darknet-basics",
    name: "暗网基础认知",
    description: "了解暗网的定义、层级结构与技术基础，建立正确的暗网认知框架。",
    icon: "ri-global-line",
  },
  {
    slug: "operation-mechanism",
    name: "暗网运作机制",
    description: "深入解析Tor网络、加密货币交易、暗网市场的技术架构与运作模式。",
    icon: "ri-settings-3-line",
  },
  {
    slug: "risk-identification",
    name: "暗网风险识别",
    description: "识别暗网中的诈骗、恶意软件、数据泄露等常见安全风险与威胁。",
    icon: "ri-alert-line",
  },
  {
    slug: "personal-protection",
    name: "个人信息防护",
    description: "学习密码管理、双因素认证、隐私设置等实用的个人信息安全防护技巧。",
    icon: "ri-shield-check-line",
  },
  {
    slug: "legal-compliance",
    name: "法律法规解读",
    description: "了解中国网络安全法、数据安全法、个人信息保护法等相关法律法规。",
    icon: "ri-scales-line",
  },
  {
    slug: "case-analysis",
    name: "案例分析与警示",
    description: "通过真实案例分析，揭示暗网犯罪的危害，提高安全防范意识。",
    icon: "ri-file-search-line",
  },
];